import { VoucherDesignModel } from '../../model/voucher-design.model';
import { BasketOfferModel } from './basket-offer.model';

export enum BasketShippingEnum {
  EMAIL = 'email',
  GLS_PICKUP = 'gls_pickup_points',
  GLS_DELIVERY = 'gls_delivery',
  MPL_DELIVERY = 'mpl_delivery',
  PERSONAL_PICKUP = 'personal_pickup'
}

export enum BasketOverviewListEnum {
  BASKET = 'basket',
  GIFT_PACKAGE = 'gift_package',
}

export interface GLSPickupPointAddressModel {
  city: string;
  address: string;
  postalCode: string;
  countryCode: string;
}

export interface GLSPickupPointModel {
  id: number;
  name: string;
  contact: GLSPickupPointAddressModel;
}

export enum DeliveryTypeEnum {
  EMAIL = 'email',
  DELIVERY = 'delivery',
}

export interface GiftWrapperBoxSelectionChange {
  value: boolean;
  box_id: string;
  item: AssignedWrapItem;
}

export interface GiftWrapperModel {
  id: number;
  name: string;
  vat: number;
  net_price: number;
  gross_price: number;
  base_picture: string;
  pictures: string[];
  max_voucher_number: number;
}

export interface AssignedWrapItem {
  id: string;
  index: number;
  selected: boolean;
  disabled: boolean;
  basket_row_id: string;
  basket: BasketOfferModel | undefined | null
}

export interface GiftWrapperBoxModel {
  id: string;
  wrap_id: number | null;
  gross_price: number | null;
  assigned: AssignedWrapItem[];
}

export interface ShippingModel {
  id: BasketShippingEnum;
  display_name: string;
  gross_price: number;
  vat?: number;
  net_price?: number;
  picture?: string;
}

export interface BasketOverviewGiftFormModel {
  name: string;
  email: string;
  message: string;
  deliveryType?: DeliveryTypeEnum;
  voucherDesign?: VoucherDesignModel;
}

export interface BasketGiftPackagesShippingModel {
  price: number;
  shipping_method: BasketShippingEnum;
  pickup_point_address?: GLSPickupPointModel;
}
